import {turnLights} from "./TurnOnOffLights";

export default (args) => turnLights(args, false);